import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ScreenTransition from "../../util/ScreenTransition";
import LoadingScreenEvent from "../event/LoadingScreenEvent";

export default class LoadingScreenCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);

        this._handleHideRequestBound = this._handleHideRequest.bind(this);
    }

    execute(evt) {
        this._showLoadingScreen();

        this._dispatcher.addEventListener(LoadingScreenEvent.HIDE_REQUEST, this._handleHideRequestBound);
    }

    _handleHideRequest(evt) {
        this._dispatcher.removeEventListener(LoadingScreenEvent.HIDE_REQUEST, this._handleHideRequestBound);

        this._hideLoadingScreen();
    }

    _showLoadingScreen() {
        this._screenSkin = this.openPopup(SkinKeyRegistry.LOADING_SCREEN_SKIN, null, {
            needsOverlay: false,
            priority: 10,
            ...ScreenTransition.fadeColorIn,
        });
    }

    _hideLoadingScreen() {
        this.closePopup(this._screenSkin, {
            ...ScreenTransition.fadeColorOut,
        });
        delete this._screenSkin;
    }
}